export default "__VITE_ASSET__8daee872__"